import { createSlice } from '@reduxjs/toolkit';
import getAdapter from '../getAdapter';

const endorsementTypesAdapter = getAdapter({ idFieldName: 'value' });

const endorsementTypesSlice = createSlice({
  name: 'endorsementTypes',
  initialState: endorsementTypesAdapter.getInitialState(),
  reducers: {
    setEndorsementTypes: (state, { payload: { endorsementTypes } }) => {
      endorsementTypesAdapter.setAll(state, endorsementTypes);
    },
  },
});

const selectors = endorsementTypesAdapter.getSelectors(({ endorsementTypes }) => endorsementTypes);

export const getEndorsementTypes = (state) => selectors.selectAll(state);

export const {
  setEndorsementTypes,
} = endorsementTypesSlice.actions;

export default endorsementTypesSlice.reducer;
